import getStyles from "./styles";
import type { IPrivacyPolicyProps } from "../../types";
import { Close } from "@mui/icons-material";
import { Box, Fab, Modal } from "@mui/material";

export default function _PrivacyPolicy(props: IPrivacyPolicyProps) {
  const { url, isOpen, handleClose } = props;

  const styles = getStyles();

  return (
    <Modal
      open={isOpen}
      closeAfterTransition
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
      sx={styles.root}
    >
      <>
        <Box component="iframe" title="Privacy Policy" src={url as string} sx={styles.wrapper}>
          PrivacyPolicy
        </Box>

        <Fab onClick={handleClose} sx={styles.close}>
          <Close />
        </Fab>
      </>
    </Modal>
  );
}
